<template>
    <section>
        <div class="swiper-box">
            <div class="swiper-main">
                <swiper v-if="store.slides.length" :options="swiperOption" style="background: #000">
                    <swiper-slide v-for="(v, k) in store.slides" :key="k" class="swiper-slide" :style="`background-image: url(${v})`"></swiper-slide>
                    <div v-show="store.slides.length > 1" class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </div>
        <div class="store-item">
            <div class="store-title">{{store.name}}</div>
            <div class="store-address"><i class="icon-location"></i> {{store.address}}</div>
        </div>

        <div class="store-item">
            <div>
                <i class="icon-phone"></i> 电话：<span class="store-phone">{{store.phone}}</span>
            </div>
        </div>

        <div class="store-item">
            <div class="store-offtime-title"> <i class="icon-time"></i> 营业时间</div>
            <div class="store-offtime">{{store.offtime}}</div>
        </div>

        <div class="store-item">
            <div class="store-offtime-title"> <i class="icon-lesson"></i> 课程安排</div>
            <!--<div :style="`background-image: url(${store.card})`" class="store-card"></div>-->
            <img :src="store.card" class="store-card" alt="">
        </div>
    </section>
</template>

<script>
    export default {
        data: () => ({
            store: {
                slides: [],
                name: '',
                address: '',
            },
            swiperOption: {
                autoplay: true,
                loop : true,
                pagination: {
                    el: '.swiper-pagination'
                },
            },
        }),
        computed: {
            id() {
                return +this.$route.params.id || 0;
            },
        },
        beforeMount() {
            this.api.get(`stores/${this.id}`).then(e => this.store = e, this.err);
        }
    }
</script>

<style scoped>
    @import '../../../static/css/store/detail.css';
</style>


// WEBPACK FOOTER //
// src/components/store/Detail.vue